import { render, staticRenderFns } from "./SuperadminEmployee.vue?vue&type=template&id=33ba65e0&scoped=true&"
import script from "./SuperadminEmployee.vue?vue&type=script&lang=js&"
export * from "./SuperadminEmployee.vue?vue&type=script&lang=js&"
import style0 from "./SuperadminEmployee.vue?vue&type=style&index=0&id=33ba65e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ba65e0",
  null
  
)

export default component.exports